import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../store/auth";
import { Link } from "react-router-dom";

// import NotFound from "../404";

const LeadCraftBonus = () => {
  const dispatch = useDispatch();
  //   const access = useSelector((state) => state.auth.access);
  const subdomain_name = useSelector(state => state.auth.product.subdomain_name)

  useEffect(() => {
    document.title = `${subdomain_name ? subdomain_name : 'Engageleads'} | LeadCraft AI`;
  },[subdomain_name]);

  useEffect(() => {
    dispatch(authActions.setLoaderStatus({ status: false }));
  });


  return (
    <>
      <section className="mid_wrap">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-4 pb-2">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                LeadCraft AI
              </li>
            </ol>
          </nav>
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="bx_a">
                <div className="emptyDiv">
                  <img
                    src="https://leadcraftai.engageleads.net/assets/images/leadcraftai_black.png"
                    alt="img"
                    className="mt-4"
                  />
                  <br />
                  <h4 className="mb-4">LeadCraft AI Login Access</h4>
                  <h6><strong className="text-secondary">Email : </strong> (**Your Paypal Email**)</h6>
                  <h6><strong className="text-secondary">Password : </strong> pQtsUoRftZ</h6>
                  <a
                    className="btn mt-3"
                    href="https://leadcraftai.engageleads.net/login"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Click here to access LeadCraft AI
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LeadCraftBonus;
